import { FormikProps } from "formik"
import React, { useRef } from "react"
import { MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SETTINGS_VAT_CODES_ROUTE } from "../../../../../constants/routes"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { useApiMutation } from "../../../../../core/api/useApiMutation"
import { SuccessDisplay } from "../../../../../core/api/errorTypes"

import { useNavigate } from "react-router"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { createVatCodeApi, VatCodesQuery } from "../vatCodesApi"
import { CreateOrEditVatCodesFormValues } from "../vatCodesTypes"
import { CreateUpdateVatCodeForm } from "../components/CreateUpdateVatCodeForm"

export function CreateVatCode() {
    const navigate = useNavigate()
    const vatCodeFormRef = useRef<FormikProps<CreateOrEditVatCodesFormValues>>(null)
    const { merchantId } = useMerchant()

    const handleSaveClick = () => {
        vatCodeFormRef.current?.submitForm()
    }

    const { mutate: callCreateVatCodes } = useApiMutation(createVatCodeApi, {
        successDisplay: SuccessDisplay.SNACKBAR,
        async onSuccess(_, __, context) {
            await context.queryClient.invalidateQueries({ queryKey: [VatCodesQuery.LIST] })
            navigate(MERCHANT_ADMIN_SETTINGS_VAT_CODES_ROUTE)
        },
    })

    const createVatCode = (data: CreateOrEditVatCodesFormValues) => {
        callCreateVatCodes({
            merchant: {
                id: merchantId,
            },
            code: data.code,
            name: data.name,
            vatPercentage: {
                amount: (data.vatPercentage.amount ?? 0) * Math.pow(10, 1),
                scale: 1,
            },
        })
    }

    return (
        <>
            <LocalizedStrict id="merchant-vat-codes-create-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.MERCHANT_CREATE_VAT_CODES_LIST}
                    title="Create VAT code"
                    rightElement={
                        <LocalizedStrict id="merchant-vat-codes-create-button">
                            <StandardButton onClick={handleSaveClick}>Create</StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-settings-header">
                            <Breadcrumb>Settings</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-vat-codes">
                            <BreadcrumbLink to={MERCHANT_ADMIN_SETTINGS_VAT_CODES_ROUTE}>VAT codes</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-create-vat-code">
                            <Breadcrumb>Create VAT code</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <CreateUpdateVatCodeForm ref={vatCodeFormRef} onSubmit={createVatCode} />
        </>
    )
}
